// Class for abstracting out generic styling conventions
// Note: For workflow-specific stylings, create a new file in the respective folder.

export const FONT_SIZE_CLASS = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
};
